import React, { useState } from 'react';
import 'antd/dist/antd.css';
import './routes.css';
import { Navbar } from '../../components/Navbar';
import routeImage from "../../images/route.png";
import { RouteMap } from '../../components/routeMap/';
import BtnTheme from '../../components/buttonTheme/';
import { BsChevronDown } from "react-icons/bs";
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { apiRoutesActions, routes } from '../../features/api_routes/apiRouterSlice';
import { apiNodePointsActions, nodePoints } from '../../features/api_node_points/apiNodePointsSlice';
import { FaArrowLeftLong } from "react-icons/fa6";
import configService from '../../services/configService';

export enum RoutesTypes {
  allRoutes = 'allRoutes',
  easyRoutes = 'easyRoutes',
  mediumRoutes = 'mediumRoutes',
  hardRoutes = 'hardRoutes',
}


export const RoutesLayout: React.FC = () => {
  const [isCollapsed, setCollapsed] = useState<boolean>(false);
  const [routesSelected, setChangeRouteType] = useState<RoutesTypes>(RoutesTypes.allRoutes);
  const dispatch = useDispatch();
  const routesList = useSelector(routes);
  const [routesListSaved, setRoutesListSaved] = useState<Array<any>>([]);
  const [routeSelected, setRouteSelected] = React.useState<any>(null);
  const nodes = useSelector(nodePoints);
  const [nodeList, setNodePoints] = useState<Array<any>>([]);
  const [isMobile, setIsMobile] = useState(false);
  const [moreInfo, setMoreInfo] = useState(false);



const isNodePointsEnabled = configService.isNodePointsEnabled();

  const onCollapse = (collapsed: boolean) => {
    console.log(collapsed);
    setCollapsed(collapsed);
  };

  const changeRouteType = (routeType: RoutesTypes) => {
    setChangeRouteType(routeType);
  };


  const handleButtonClick = (route: any) => {
    setRouteSelected(route);
  };

  const handleMoreInfo = () => {
    setMoreInfo(!moreInfo)
  };

  const handleCloseMoreInfo = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setMoreInfo(false);
  };


  useEffect(() => {
    const checkMobile = () => {
      const screenWidth = window.innerWidth <= 768;
      const isMobileDevice = screenWidth;

      setIsMobile(isMobileDevice);
    };

    // Check on mount
    checkMobile();

    // Listen for resize events
    window.addEventListener('resize', checkMobile);

    // Cleanup
    return () => window.removeEventListener('resize', checkMobile);
  }, []);


  useEffect(() => {
    if (!routesList) {
      dispatch(
        apiRoutesActions.fetchGetRoutes({})
      );

    }
    if (routesList) {

      const auxList = [];
      for (const element of routesList) {
        auxList.push(element);
      }
      setRoutesListSaved(auxList);
      setRouteSelected(auxList[0])
    }
  }, [routesList]);

  const styles = {
    overflow: 'auto',
    height: '80%',
    top: 0,
    bottom: 0,
  };

  useEffect(() => {
    if (nodeList.length === 0) {
      dispatch(
        apiNodePointsActions.fetchGetNodePoints({})
      );
    }
    if (nodes) {
      console.log(nodes);
      const auxList = [];
      for (const element of nodes) {
        auxList.push(element);

      }
      setNodePoints(auxList);
    }
  }, []);


  return (
    <>
      <Navbar />

      <div className="parent">
        <div className={`${isMobile ? 'bottom-sheet ' : 'left-sider'}`} style={{ height: isCollapsed ? '100px' : '' }} >
          <div className={`list-view-parent ${isMobile && moreInfo ? 'hidden' : ''}`}>
            <div className="title-container padded-left-16">
              <span className="title-text">Lista de rutas</span>
              {isMobile && (
                <BsChevronDown
                  style={{
                    transform: isCollapsed ? 'rotate(180deg)' : 'rotate(0deg)',
                    transitionDuration: '0.4s',
                    fontSize: 20,
                  }}
                  onClick={() => {
                    setCollapsed(!isCollapsed)
                  }}
                />

              )}
            </div>

            <div className="flex-start-container padded-left-16">
              <span className="count-routes">{routesListSaved.length} Total</span>
            </div>

      {isNodePointsEnabled && ( 
            <div className="create-route-section">
              <div className="create-route-button" onClick={() => window.location.href = '/'}>
                <div className="create-route-button-background"></div>
                <div className="create-route-button-text">+</div>
              </div>

              <div className="create-route-description">Crear nueva ruta personalizada!</div>
            </div>

      )}


            <div className="list">
              {routesListSaved != null &&
                routesListSaved.map((route: any, index: number) => {
                  const isSelected =
                    routeSelected != null &&
                    routeSelected.id === route.id;

                  return (
                    <div
                      key={index}
                      className={`route-card ${isSelected ? 'selected' : ''}`}
                      onClick={() => handleButtonClick(route)}
                    >
                      <div className="route-content">
                        <div className="route-info">
                          <img className="route-image" src={routeImage} alt="route" />
                          <div className="route-text">
                            <div className="route-name-row">
                              <span className="nameText">{route.nombre}</span>
                              {route.greatRoute && (
                                <span className="great-route-tag">Ruta destacada</span>
                              )}
                            </div>
                          </div>
                        </div>
                        <BtnTheme text='+Info' onClick={handleMoreInfo} className={`${isSelected ? '' : 'hidden'}`} ></BtnTheme>
                      </div>
                    </div>
                  );
                })}

            </div>
          </div>
          {
            routeSelected != null && (
              <div className={`route-sheet ${moreInfo ? 'active' : ''}`} >
                <div className="scrollable-container">
                  <div className="title-container ">
                    <div style={{ paddingTop: '0px', display: 'inline-flex', justifyContent: 'space-between', width: '100%' }} onClick={
                      handleMoreInfo}>
                      <FaArrowLeftLong color='#625B71' style={{ width: '20px', height: '20px', paddingTop: '3px', display: isMobile ? 'block' : 'none' }} />
                      {isMobile && (
                        <BsChevronDown
                          style={{
                            transform: isCollapsed ? 'rotate(180deg)' : 'rotate(0deg)',
                            transitionDuration: '0.5s',
                            fontSize: 20,
                          }}
                          onClick={(e) => {
                            e.stopPropagation(); // Prevent event bubbling
                            setCollapsed(!isCollapsed)
                          }}
                        />

                      )}
                    </div>
                  </div>
                  <div className="route-sheet-actions">
                    <BtnTheme text='Cerrar' onClick={handleCloseMoreInfo} />
                  </div>
                  <div className="results-section">
                    <span className="title-text">{routeSelected.nombre}</span>
                  </div>
                  <div className="description-route-container">
                    <span className="descriptionRoute">{routeSelected.descripción}</span>
                  </div>
                  <div className="results-section spacing-block">
                    <span className="distanceSpan"> Distancia: {routeSelected.distancia}</span>
                    <span className="distanceSpan"> Desnivel: {routeSelected.desnivel}</span>
                    <span className="distanceSpan"> Dificultad: {routeSelected.dificultad}</span>
                  </div>

                  <div className='gpx-download-container'>
                    <button
                      className='buttonSelected'
                      onClick={() => {
                        if (routeSelected?.signed_url) {
                          const link = document.createElement('a');
                          link.href = routeSelected.signed_url;
                          link.download = `${routeSelected.nombre}.gpx`;
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                        }
                      }}
                    >
                      Descargar GPX
                  </button>
                  </div>
                </div>
              </div>
            )
          }


        </div >

        <RouteMap gpxUrl={routeSelected?.signed_url} isMobile={isMobile} />
      </div >
    </>
  );


}
